import { useNavigate } from 'react-router-dom'
import { Row, Col } from 'react-bootstrap'
import { IPageProps, IRootState, } from 'types'
import { DefaultButton, FormDropDownList, FormInput, PageHeader } from 'components'
import { useRef, useState } from 'react'
import { FormElement, Field, Form, FormClassComponent, } from '@progress/kendo-react-form'
import { useDispatch, useSelector } from 'react-redux'
import { RequiredValidator } from 'core/Validators'
import { Label } from '@progress/kendo-react-labels'
import { GetCMSCacheObject } from 'generated/v1/v1IntegrationsApi'
import { AppDispatch } from 'state/store'
import { endLoadingAction, startLoadingAction } from 'state/actions/appActions'
import { V1ApiIntegrationsClient } from 'core/http-common'
import toast from 'core/toast'
import JSONPretty from 'react-json-pretty'

const CMSCachePage = ({ title }: IPageProps) => {

    const formRef = useRef<FormClassComponent>(null)
    const loading = useSelector((state: IRootState) => state.app.loading)
    const dispatch = useDispatch<AppDispatch>()
    const [resultText, setResultText] = useState<string | undefined>('Results show here')

    const enviromentData = ['Production', 'QA']
    const keyData = ['Products', 'Inventory', 'InventoryList']

    const handleSubmit = async (values: GetCMSCacheObject) => {
        try {
            await dispatch(startLoadingAction())

            var result = await V1ApiIntegrationsClient.getObjectFromCache(
                new GetCMSCacheObject({
                    environment: values.environment,
                    key: values.key,
                    value: values.value
                }))

            if (result.success) {
                setResultText(result.payload?.result)
            }

        } catch (e) {
            toast.responseErrors(e)
        }
        finally {
            await dispatch(endLoadingAction())
        }
    }

    return (
        <div>
            <PageHeader title={title} />

            <Form
                onSubmit={(e) => handleSubmit(e as GetCMSCacheObject)}
                ref={formRef}
                ignoreModified={true}
                render={(formRenderProps) => (
                    <FormElement>
                        <div className='bg-light border p-3'>
                            <Row className='mb-3'>
                                <Col md={3} className='mb-3 mb-md-0'>
                                    <Field
                                        label='Select Enviroment:'
                                        name='environment'
                                        component={FormDropDownList}
                                        defaultValue=''
                                        data={enviromentData}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Field
                                        label='Cache Key:'
                                        name='key'
                                        validator={RequiredValidator}
                                        component={FormDropDownList}
                                        defaultValue=''
                                        data={keyData}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Field
                                        label='Value:'
                                        name='value'
                                        component={FormInput}
                                        validator={RequiredValidator}
                                    />
                                </Col>
                                <Col md={3} style={{ alignSelf: 'end' }}>
                                    <DefaultButton
                                        variant='primary'
                                        className='w-100 mt-4'
                                        disabled={loading}
                                        type='submit'>
                                        Show Results

                                    </DefaultButton>
                                </Col>
                                <Col xs={12}>
                                    <Label>Cache Results:</Label>
                                    <div className='bg-white border p-3'>
                                        <JSONPretty id='json-pretty' data={resultText}></JSONPretty>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </FormElement>
                )
                }
            />
        </div>
    )
}
export default CMSCachePage
